import React from 'react';
import faqFile from '../../assets/faq.json';
import styles from './faqStyles.scss';
import { FAQCard } from './FAQCard';
import { useIsRtsRebrand } from '../../../common/useRtsRebrand';
import { useAppSelector } from '../../../store';
import FreightFaqContainer from './FreightFaqContainer';
import { FeatureFlags } from '@Common/featuresFlagsTypes';

export const FAQContainer = () => {
  const isRebrand = useIsRtsRebrand();
  const { userFeatures } = useAppSelector((state) => state.adminShell);
  const freightPermissionsEnabled = userFeatures?.includes(FeatureFlags.FREIGHT_PERMISSIONS_WEB);

  return (
    <div className={styles.faqContainer}>
      {faqFile.faqs.map((faq) => {
        const answer =
          isRebrand && 'answer_rebrand' in faq ? (faq as { answer_rebrand: string }).answer_rebrand : faq.answer;
        return <FAQCard key={faq.id} qText={faq.question} aText={answer} />;
      })}
      {freightPermissionsEnabled && <FAQCard qText={'Understanding Freight access'} aText={<FreightFaqContainer />} />}
    </div>
  );
};
